<template>
<div>
    <bar-manut 
        single-entity="Equipe" 
        plural-entity="Equipe" 
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <div>
        <div class="default-container">
            
            <div class="row">
                <form-field ref="nome" v-model="equipe.nome" type="text" col="6" :metadata="metadata.equipe.nome" 
                    case="normal" 
                    name="nome" :v-errors="errors" v-validate="metadata.equipe.nome.validator"></form-field>
            </div>                

            <hr>
            <label-title title="Usuários da Equipe" icon="fa-group" class="nb-margin-bottom nb-margin-top"></label-title>
            <div class="row">
                <form-field v-model="codusuario" type="select2" col="6" id="usuario" label="Selecione os Usuários"
                    :select2="{entity: 'usuario', minlength: 0}"></form-field>
            </div>
            <div class="row">
                <div class="col-md-12 col-12">
                    <div class="mainbox" v-for="(valor, index) in equipeit" :key="index">                    
                        <div class="box">
                            <div class="row align-items-center">                                                        
                                <div class="col-md-8 col-6">
                                    <i v-if="valor.responsavel=='S'" class="lbl fa fa-user-secret mr-2" style="font-size: 28px"></i>
                                    <i v-else class="lbl fa fa-user mr-2" style="font-size: 28px"></i>
                                    <span class="lbl">{{ valor.nome }}</span>
                                </div>
                                <div class="col-md-3 col-6">
                                    <v-button label="" title="Excluir Item" icon="fa-trash" @click="handleDeleteUsuario(index)"></v-button>
                                    <v-button v-if="valor.responsavel!='S'" label="Marcar como responsável" title="" icon="fa-user-secret" @click="handleDefineResponsavel(index)"></v-button>
                                    <v-button v-else label="Remover responsável" title="" icon="" @click="handleRemoveResponsavel(index)"></v-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    components: {
    },

    data() {
        return {
            crudText: '',
            equipe: {...this.$store.getters.getEntities.equipe},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
            equipeit: [],
            codusuario: '',
            usuario: null,
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }
    },

    watch: {
        codusuario: function () {
            if (this.codusuario) {
                this.handleNewUsuario()
            }
        },
    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.equipe.codequipe)
        },

        handleSave () {
            //BOTAO SALVAR
            var valido = true;

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else if (valido) {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            this.apiDelete()
        },       

        handleDeleteUsuario (index) {            
            this.equipeit.splice(index,1)
        },

        handleDefineResponsavel (index) {            
            this.equipeit[index].responsavel = 'S'
        },

        handleRemoveResponsavel (index) {            
            this.equipeit[index].responsavel = 'N'
        },

        async handleNewUsuario () {           
            // Verifica se o usuario já não foi adicionado
            if (this.equipeit) {
                for(var i=0; i<this.equipeit.length; i++) {
                    if(this.equipeit[i].codusuario === this.codusuario) {
                        return
                    }
                }
            }

            await this.$store.dispatch('loadUsuario', { id: this.codusuario } )
            if (this.$store.getters.getUsuario) {
                this.usuario = {...this.$store.getters.getUsuario}
            }
 
            var p = {
                codusuario: this.codusuario,
                codequipe: this.equipe.codequipe,
                codequipeit: null,
                responsavel: 'N',
                nome: this.usuario.nome
            }

            this.equipeit.push(p)
            this.codusuario = null        
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadEquipe', { id: this.index } )
            if (this.$store.getters.getEquipe) {
                this.equipe = {...this.$store.getters.getEquipe}
                this.equipeit = this.equipe.equipeit
            }
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/equipe/' + this.equipe.codequipe

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/equipe/'
            this.equipe.equipeit = this.equipeit
            var sendData = { equipe: this.equipe }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },

    },

    beforeCreate () {

    },

    created () {
        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
        } else {
            this.loadData()  
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.nome.focus()
        })

    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/equipe-form.vue